import { d as i } from "./index-21b082e6.js";
import "./en-4402d6fc.js";
var n = {
  name: "gd",
  weekdays: "Didòmhnaich_Diluain_Dimàirt_Diciadain_Diardaoin_Dihaoine_Disathairne".split("_"),
  months: "Am Faoilleach_An Gearran_Am Màrt_An Giblean_An Cèitean_An t-Ògmhios_An t-Iuchar_An Lùnastal_An t-Sultain_An Dàmhair_An t-Samhain_An Dùbhlachd".split("_"),
  weekStart: 1,
  weekdaysShort: "Did_Dil_Dim_Dic_Dia_Dih_Dis".split("_"),
  monthsShort: "Faoi_Gear_Màrt_Gibl_Cèit_Ògmh_Iuch_Lùn_Sult_Dàmh_Samh_Dùbh".split("_"),
  weekdaysMin: "Dò_Lu_Mà_Ci_Ar_Ha_Sa".split("_"),
  ordinal: function(a) {
    return a;
  },
  formats: {
    LT: "HH:mm",
    LTS: "HH:mm:ss",
    L: "DD/MM/YYYY",
    LL: "D MMMM YYYY",
    LLL: "D MMMM YYYY HH:mm",
    LLLL: "dddd, D MMMM YYYY HH:mm"
  },
  relativeTime: {
    future: "ann an %s",
    past: "bho chionn %s",
    s: "beagan diogan",
    m: "mionaid",
    mm: "%d mionaidean",
    h: "uair",
    hh: "%d uairean",
    d: "latha",
    dd: "%d latha",
    M: "mìos",
    MM: "%d mìosan",
    y: "bliadhna",
    yy: "%d bliadhna"
  }
};
i.locale(n, null, !0);
export {
  n as default
};
